import * as React from 'react';

import { IPartner } from '../../store/models';

import './index.scss';

interface IProps {
    partners: IPartner[];
}

export const CustomersList: React.FC<IProps> = ({ partners }) => {
    return (
        <div className="customers">
            <div className="container">
                <ul>
                    {
                        partners.map((partner) => (
                            <li key={partner.id}>
                                <img src={partner.photo} alt={partner.title} />
                            </li>
                        ))
                    }
                </ul>
            </div>
        </div>
    );
};
